import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment partialUser on User {
    uuid
    email
    firstname
    lastname
    profile_img
    firstName
    lastName
    profileImageUrl
    isEnabled
    isActivated
  }
`

export const partialUserList = gql`
  fragment partialUserList on UserList {
    limit
    count
    offset
    results {
      ...partialUser
    }
  }
  ${fragment}
`

export const toString = fragment.loc.source.body

export default fragment
